document.addEventListener('DOMContentLoaded', () => {
  /********************************
   * Vars
   *******************************/
  const body = document.querySelector('body')
  const screenWidth = window.innerWidth;

  /********************************
   * Collection page: show or hide mobile filter
   *******************************/
  const featuredProductsSection = document.querySelector('.featured-products-section');

  if(featuredProductsSection){
    const buttonDrawerTrigger = featuredProductsSection.querySelector('.collection-drawer-trigger');
    const filterDrawer = featuredProductsSection.querySelector('.collection-aside-inner');

    if(buttonDrawerTrigger && filterDrawer){
      const buttonHideDrawer = filterDrawer.querySelector('.btn-close');

      buttonDrawerTrigger.addEventListener('click', () => filterDrawer.classList.add('show'));
      buttonHideDrawer.addEventListener('click', () => filterDrawer.classList.remove('show'));
    }
  }

  /********************************
   * Section: single-product
   *******************************/
  const singleProduct = document.querySelector('.single-product');

  if (singleProduct) {
    const mainSliderInit = singleProduct.querySelector('.slider-main_init');
    const thumbsSliderInit = singleProduct.querySelector('.slider-thumbs_init');

    if (mainSliderInit) {
      let thumbsSwiper = null;
      let mainSwiper = null;

      const isType1 = singleProduct.classList.contains('type-1');
      const isType2 = singleProduct.classList.contains('type-2');

      const thumbSize = 67;
      const thumbSpace = 10;
      const mobileBreakpoint = 767;

      const syncThumbsHeight = () => {
        if (!thumbsSliderInit) return;

        if (isType1 && window.innerWidth > mobileBreakpoint) {
          thumbsSliderInit.style.height = `${mainSliderInit.offsetHeight}px`;
        } else {
          thumbsSliderInit.style.height = '';
        }
      };

      const getThumbsPerView = () => {
        if (!thumbsSliderInit) return 1;

        if (isType2) {
          return window.innerWidth <= mobileBreakpoint ? 3 : 4;
        }

        const thumbsHeight = thumbsSliderInit.offsetHeight;
        if (!thumbsHeight) return 1;

        return Math.max(1, Math.floor((thumbsHeight + thumbSpace) / (thumbSize + thumbSpace)));
      };

      const getThumbsDirection = () => {
        if (isType2) {
          return 'horizontal';
        }

        return window.innerWidth > mobileBreakpoint ? 'vertical' : 'horizontal';
      };

      const initThumbsSwiper = () => {
        if (!thumbsSliderInit) return null;

        if (isType1 && window.innerWidth <= mobileBreakpoint) return null;

        syncThumbsHeight();

        return new Swiper(thumbsSliderInit, {
          direction: getThumbsDirection(),
          spaceBetween: thumbSpace,
          slidesPerView: getThumbsPerView(),
          watchSlidesProgress: true,
          watchOverflow: true
        });
      };

      const initMainSwiper = () => {
        return new Swiper(mainSliderInit, {
          loop: true,
          spaceBetween: 10,
          navigation: {
            nextEl: '.slider-button-next',
            prevEl: '.slider-button-prev'
          },
          thumbs: {
            swiper: thumbsSwiper
          }
        });
      };

      const destroySwipers = () => {
        if (mainSwiper) {
          mainSwiper.destroy(true, true);
          mainSwiper = null;
        }

        if (thumbsSwiper) {
          thumbsSwiper.destroy(true, true);
          thumbsSwiper = null;
        }
      };

      const initSliders = () => {
        destroySwipers();

        thumbsSwiper = initThumbsSwiper();
        mainSwiper = initMainSwiper();
      };

      const updateThumbsSwiper = () => {
        if (!thumbsSwiper) return;

        syncThumbsHeight();
        thumbsSwiper.changeDirection(getThumbsDirection());
        thumbsSwiper.params.slidesPerView = getThumbsPerView();
        thumbsSwiper.update();
      };

      initSliders();

      let resizeTimer = null;

      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(() => {
          const shouldReinit =
              (isType1 && window.innerWidth <= mobileBreakpoint && thumbsSwiper) ||
              (isType1 && window.innerWidth > mobileBreakpoint && !thumbsSwiper);

          if (shouldReinit) {
            initSliders();
          } else {
            syncThumbsHeight();
            updateThumbsSwiper();

            if (mainSwiper) {
              mainSwiper.update();
            }
          }
        }, 100);
      });
    }
  }

  /********************************
   * Accordion
   *******************************/
  const accordionGroups = document.querySelectorAll('.accordion-wrap');

  if (accordionGroups.length > 0) {
    accordionGroups.forEach(accordion => {
      const isAccordionActive = () => {
        const isMenu = accordion.classList.contains('header-main-navigation');
        const isMobile = window.innerWidth <= 991;
        return isMenu ? isMobile : true;
      };

      const initAccordions = () => {
        if (!isAccordionActive()) return;

        if (accordion.classList.contains('open-first-child')) {
          setTimeout(() => {
            const firstItem = accordion.querySelector('.accordion-item');
            if (firstItem) openAccordionItem(firstItem);
          }, 1300);
        }

        if (accordion.classList.contains('open-all-child')) {
          setTimeout(() => {
            const allItems = accordion.querySelectorAll('.accordion-item');
            allItems.forEach(item => openAccordionItem(item));
          }, 1300);
        }
      };

      const openAccordionItem = (item) => {
        const content = item.querySelector('.accordion-description');
        const inner = item.querySelector('.accordion-inner-content');
        const padding = +item.dataset.descriptionPadding || 12;

        item.classList.add('active');
        content.style.height = (inner.scrollHeight + padding) + "px";
      };

      const closeAccordionItem = (item) => {
        const content = item.querySelector('.accordion-description');
        item.classList.remove('active');
        content.style.height = "0px";
      };

      accordion.addEventListener('click', function (e) {
        if (!isAccordionActive()) return;

        const target = e.target;
        const accordionItem = target.closest('.accordion-item');

        if (!accordionItem || target.closest('.accordion-description')) return;

        const isActive = accordionItem.classList.contains('active');
        const activeItem = accordion.querySelector('.accordion-item.active');

        if (isActive) {
          closeAccordionItem(accordionItem);
        } else {
          if (activeItem) closeAccordionItem(activeItem);
          openAccordionItem(accordionItem);
        }
      });

      window.addEventListener('resize', () => {
        if (accordion.classList.contains('header-main-navigation') && window.innerWidth > 991) {
          const items = accordion.querySelectorAll('.accordion-item');
          items.forEach(item => {
            item.classList.remove('active');
            item.querySelector('.accordion-description').style.height = '';
          });
        }
      });

      initAccordions();
    });
  }

  /********************************
   * Section: featured-products
   *******************************/
  const sectionFeaturedProducts = document.querySelectorAll('.featured-products');

  if (sectionFeaturedProducts.length) {
    function initializeSlider(slider, slideCount) {
      if (screenWidth >= 768 && slideCount > 3) {
        console.log(slider, slideCount, 'desktop')
        startSlider(slider);
      } else if (screenWidth <= 767 && slideCount > 1) {
        console.log(slideCount, 'mob')
        startSlider(slider);
      }
    }

    function startSlider(sliderInit) {
      const pagination = sliderInit.querySelector('.swiper-pagination')
      sliderInit.querySelector('.swiper-nav-wrap').classList.remove('hidden');

      new Swiper(sliderInit, {
        slidesPerView: 1.3,
        spaceBetween: 16,

        navigation: {
          nextEl: '.swiper-b-next',
          prevEl: '.swiper-b-prev',
        },

        breakpoints: {
          768: {
            spaceBetween: 16,
            slidesPerView: 2.4,
          },
          992: {
            spaceBetween: 24,
            slidesPerView: 2.4,
          },
          1200: {
            spaceBetween: 24,
            slidesPerView: 3,
          },
          1440: {
            spaceBetween: 32,
            slidesPerView: 3,
          },
        }
      });
    }

    sectionFeaturedProducts.forEach(section => {
      const slider = section.querySelector('.slider_init');
      const slideCount = section.querySelectorAll('.swiper-slide').length;

      initializeSlider(slider, slideCount)
    });
  }
});